import { render, staticRenderFns } from "./mock-credit-card-form.vue?vue&type=template&id=8bf0ae1e&scoped=true&"
import script from "./mock-credit-card-form.vue?vue&type=script&lang=js&"
export * from "./mock-credit-card-form.vue?vue&type=script&lang=js&"
import style0 from "./mock-credit-card-form.vue?vue&type=style&index=0&id=8bf0ae1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0ae1e",
  null
  
)

export default component.exports